/*
function HandleNavSelection( ) 
{
    var navInputs = document.querySelectorAll( '.nav-bar-input' );
    var collectionBlocks = document.querySelectorAll( '.collection_block' );

    function ShowSelectedCollection( selectedCategory ) 
    {
        collectionBlocks.forEach( function( block ) 
        {
            if ( block.dataset.category === selectedCategory ) 
            {
                block.style.display = 'flex';
            } 
            else 
            {
                block.style.display = 'none';
            }
        });
    }

    navInputs.forEach( function( input ) 
    {
        input.addEventListener( 'change', function( ) 
        {
            var selectedCategory = this.value;
            ShowSelectedCollection( selectedCategory );
        } );
    } );

    var initiallyChecked = document.querySelector( '.nav-bar-input:checked' );
    if ( initiallyChecked ) 
    {
        var selectedCategory = initiallyChecked.value;
        ShowSelectedCollection( selectedCategory );
    }
}

function SetupShopNowButton() 
{
    var shopNowButton = document.getElementById( 'shopNowButton' );

    shopNowButton.addEventListener( 'click', function( ) 
    {
        var visibleCollectionBlock = document.querySelector( '.collection_block:not([style*="display: none"])' );
        if ( visibleCollectionBlock ) 
        {
            var category = visibleCollectionBlock.dataset.category;
            var collection = document.querySelector( '.collection_block[data-category="' + category + '"]' );
            if ( collection ) 
            {
                var collectionUrl = collection.getAttribute( 'data-url' );
                if ( collectionUrl ) 
                {
                    // window.location.href = collectionUrl;
                }
            }
        }
    });
}

document.addEventListener( 'DOMContentLoaded', function( ) 
{
    HandleNavSelection( );
    SetupShopNowButton( );
} );
*/



function GoToActiveBlockURL() 
{
    var activeOption = document.querySelector('.hp-nav-bar-option-container.active');
    
    if (activeOption && activeOption.dataset.url) 
        {
            var url = activeOption.dataset.url;
            // window.location.href = url;
        }
}



function toggleActive( element ) 
{
    var activeContainers = document.querySelectorAll( '.hp-nav-bar-option-container.active' );
    activeContainers.forEach( function( el ) 
    {
        el.classList.remove( 'active' );
    });
    element.classList.add( 'active' );

    var pairKey = element.getAttribute( 'data-pair-key' );

    var colBlocks = document.querySelectorAll('.col-block-wrap');
    colBlocks.forEach(function(el) 
    {
        el.style.display = 'none';
        var parentImgBlockUrl = el.closest('.img-block-url');
        if (parentImgBlockUrl) 
            {
            parentImgBlockUrl.style.display = 'none';
        }
    });

    var selectedColBlocks = document.querySelectorAll('.col-block-wrap[data-pairing-text-img="' + pairKey + '"]');
    selectedColBlocks.forEach(function(el) 
    {
        el.style.display = 'flex';
        var parentImgBlockUrl = el.closest('.img-block-url');
        if (parentImgBlockUrl) 
            {
            parentImgBlockUrl.style.display = 'flex';
        }
    });
}

var shopButton = document.getElementById( 'shopNowButton' );
shopButton.addEventListener( 'click', GoToActiveBlockURL);

document.addEventListener( 'DOMContentLoaded', function() 
{
    var firstOption = document.querySelector( '.hp-nav-bar-option-container' );
    
    if ( firstOption ) 
    {
        toggleActive( firstOption );
    }

    var navBarOptions = document.querySelectorAll( '.hp-nav-bar-option-container' );

    navBarOptions.forEach( function( option ) 
    {
        option.addEventListener( 'click', function() 
        {
            toggleActive( this );
        });
    });

});